// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"BottomNav_Navbar__1esRU"};